export type TableFormat = {
  Count: number;
  Items: unknown[];
  NextPageLink: unknown;
}

export type PageFormatTable = {
  length: number;
  pageIndex: number;
  pageSize: number;
  previousPageIndex: number;
}

export enum OrderTypeColumn {
  ASC = 'asc',
  DESC = 'desc'
}